/*
 * <card-variants>
 *
 * Lightweight custom element that powers inline color-swatch variant selection
 * on collection product cards (snippets/featured-single-product.liquid).
 *
 * When a swatch radio changes it updates — client-side, from data attributes on
 * the selected input — the card image, the price shown inside the add-to-cart
 * button, every product link in the card, and the hidden variant id consumed by
 * Dawn's <product-form> (which still handles the AJAX add + cart drawer).
 *
 * No network request is made on selection, so a grid of cards stays fast.
 */
if (!customElements.get('card-variants')) {
  customElements.define(
    'card-variants',
    class CardVariants extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.onSwatchChange.bind(this));
      }

      onSwatchChange(event) {
        const input = event.target;
        if (!input.matches('input[type="radio"]')) return;

        const data = input.dataset;
        if (!data.variantId) return;

        const available = data.variantAvailable === 'true';

        this.updateImage(data.variantImage);
        this.updateLinks(data.variantUrl);
        this.updateForm(data.variantId, available);
        this.updateButton(data.variantPrice, data.variantCompare, available);
      }

      updateImage(imageUrl) {
        if (!imageUrl) return;
        const img = this.querySelector('[data-card-image]');
        if (!img) return;
        img.removeAttribute('srcset');
        img.src = imageUrl;
      }

      updateLinks(url) {
        if (!url) return;
        this.querySelectorAll('[data-card-link]').forEach((link) => {
          link.setAttribute('href', url);
        });
      }

      updateForm(variantId, available) {
        const idInput = this.querySelector('input[name="id"]');
        if (!idInput) return;
        idInput.value = variantId;
        idInput.disabled = !available;
        // Notify any listeners (mirrors Dawn's variant input change dispatch)
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateButton(price, compare, available) {
        const button = this.querySelector('.featured-single-product-atc');
        if (!button) return;

        const label = button.querySelector('.atc-label');
        const sep = button.querySelector('.atc-sep');
        const priceEl = button.querySelector('.atc-price');

        button.disabled = !available;

        if (label) {
          label.textContent = available
            ? window.variantStrings?.addToCart || label.textContent
            : window.variantStrings?.soldOut || label.textContent;
        }

        // Hide the price/separator when the variant is unavailable
        if (sep) sep.hidden = !available;
        if (priceEl) {
          priceEl.hidden = !available;
          if (available) {
            priceEl.innerHTML = compare
              ? `<del>${compare}</del> ${price || ''}`
              : price || '';
          }
        }
      }
    }
  );
}
